import { isFeatureEnabled } from 'owa-feature-flags';
export default function (feature) {
    return isFeatureEnabled(feature);
}
//# sourceMappingURL=isMailFeatureEnabled.js.map